module.exports = __webpack_public_path__ + "img/sopa-letras-crucigrama.381413b2.svg";